import React, { useEffect, useRef, useState } from "react";
import LogTimeList from "./LogTimeList";
import {
  deleteTask,
  getProjectList,
  startTask,
  stopTask,
  updateTask,
  useGetSpentTime,
  useLogsList,
  useProjectList,
  useTaskSubtaskList,
} from "./api";
import { format } from "date-fns";
import { isToday } from "date-fns";
import { isYesterday } from "date-fns";
import { getPermissionsList } from "../../helpers/getPermission";
import DefaultImage from "../../profile_images/DefaultImage";
import { isValidTime } from "../../utility/validTime";

const LogTime = () => {
  const todayDate = new Date();
  const [isActiveProjectDrop, setIsActiveProjectDrop] = useState<boolean>(false);
  const [isActiveTaskDrop, setIsActiveTaskDrop] = useState<boolean>(false);
  const [isActiveSortDrop, setIsActiveSortDrop] = useState<boolean>(false);
  const [selectedProject, setSelectedProject] = useState(localStorage.getItem("selectedProject"));
  const [selectedTask, setSelectedTask] = useState({
    task: localStorage.getItem("selectedTaskSubTask"),
    isSubTask: false,
    taskId: localStorage.getItem("selectedTaskSubTaskId"),
  });
  const [projectId, setProjectId] = useState("");
  const [taskId, setTaskId] = useState("");
  const [subTaskId, setSubtaskId] = useState({
    taskId: "",
    taskUniqueId: "",
    id: "",
  });
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
  const [projectSearchQuery, setProjectSearchQuery] = useState("");
  const [taskSearchQuery, setTaskSearchQuery] = useState("");
  const [limit, setLimit] = useState(10);
  const projectDropdownRef = useRef<HTMLDivElement>(null);
  const taskDropdownRef = useRef<HTMLDivElement>(null);
  const sortDropdownRef = useRef<HTMLDivElement>(null);
  const [loginUser, setLoginUser] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [dateFc, setDateFc] = useState(todayDate.toISOString().split("T")[0]);
  const [currentDate, setCurrentDate] = useState(todayDate);
  const [showTimeLog, setShowTimeLog] = useState(false);
  

  useEffect(() => {
    setSelectedProject(localStorage.getItem("selectedProject"));
    setSelectedTask({
      task: localStorage.getItem("selectedTaskSubTask"),
      isSubTask: false,
      taskId: localStorage.getItem("selectedTaskSubTaskId"),
    });
  },[localStorage.getItem("_id")])

  const { projectList, isProjectListLoading, isError } = useProjectList(
    limit,
    projectSearchQuery
  );
  const { taskSubtaskList, isTaskSubtaskListLoading, isTaskError } =
    useTaskSubtaskList(projectId, limit, taskSearchQuery);
    const { totalSpentTime, isSpentTimeLoading, isSpentTimeError,refetchTotalTime } =
    useGetSpentTime(dateFc);
    const { logsList, isLogListLoading, isLogError, refetch } =
    useLogsList(dateFc,sortOrder);


  useEffect(() => {
    const _getPermissions = async () => {
      let token = await getPermissionsList();
      const profile = token?.login_user?.profile;
      setLoginUser(profile?.first_name + " " + profile?.last_name);
      setProfilePic(token?.login_user?.profilepic);
      console.log("pic ", token?.login_user);
    };
    _getPermissions();
  }, []);


  const handlePrevious = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() - 1);
      console.log("dateFc ", newDate, "yyyy-MM-dd");

      setDateFc(format(newDate, "yyyy-MM-dd")); // Update the formatted date
      return newDate;
    });
  };

  const toggleSortOrder = (status: "asc" | "desc") => {
    setSortOrder(status);
    setIsActiveSortDrop((prevState) => !prevState);
  };

  const handleProjectSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setProjectSearchQuery(e.target.value);
  };

  const handleTaskSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTaskSearchQuery(e.target.value);
  };

  const handleNext = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + 1);
      setDateFc(format(newDate, "yyyy-MM-dd")); // Update the formatted date
      return newDate;
    });
  };

  const getDateLabel = () => {
    if (isToday(currentDate)) {
      return "Today";
    }
    if (isYesterday(currentDate)) {
      return "Yesterday";
    }
    return format(currentDate, "d"); // Example: "March 19, 2024"
  };

  const getMonth = (): any => {
    return format(currentDate, "MMMM"); // Example: "March"
  };

  const getYear = (): any => format(currentDate, "yyyy"); // Example: "2024"

  const parseTimeToTimestamp = (time: string | null): number => {
    if (!time) return 0; // If no time is provided, default to 0
    const now = new Date();
    const parsedDate = new Date(`${now.toDateString()} ${time}`);
    return isNaN(parsedDate.getTime()) ? 0 : parsedDate.getTime();
  };

  // Function to format seconds into hh:mm:ss
  const formatTime = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const minutes = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const secs = (seconds % 60).toString().padStart(2, "0");
    return `${hours}:${minutes}:${secs}`;
  };

  // Fetch the start time from localStorage
  const storedStartTime = localStorage.getItem("starttime");
  const initialElapsedSeconds = storedStartTime
    ? Math.floor((Date.now() - parseTimeToTimestamp(storedStartTime)) / 1000)
    : 0;

  const [time, setTime] = useState(storedStartTime ? initialElapsedSeconds : 0); // Set time based on localStorage or 0
  const [isRunning, setIsRunning] = useState(false); // Only start if there's a stored starttime
  const [isStartTask, setIsStartTask] = useState(!!storedStartTime);

  // Effect to update the timer
  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (isStartTask) {
      timer = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    }

    return () => {
      if (timer) clearInterval(timer); // Cleanup interval on unmount
    };
  }, [isStartTask]);

    useEffect(() => {
        if (localStorage.getItem("_id")) {
          setIsRunning(true);
    }
  }, [localStorage.getItem("_id")])

  useEffect(() => {
    refetch();
  }, [dateFc]);
   

  const clearTaskState = () => {
    setIsStartTask(false);
    setIsRunning(false);
    setTime(0);
    setSelectedProject("");
    setSelectedTask({ task: "", isSubTask: false, taskId: "" });
    setProjectId("");
    setTaskId("");
    setSubtaskId({ taskId: "", taskUniqueId: "", id: "" });
  
    localStorage.removeItem("starttime");
    localStorage.removeItem("_id");
    localStorage.removeItem("selectedTaskSubTask");
    localStorage.removeItem("selectedTaskSubTaskId");
    localStorage.removeItem("selectedProject");
  
    refetch();
    refetchTotalTime();
  };

  const handleClone = (log: any, status: string) => {

    if (status === 'play') {

      setDateFc(format(todayDate, 'yyyy-MM-dd'));
      setCurrentDate(todayDate);

   const localDate = new Date(dateFc);
      const utcDate = new Date(
        localDate.getTime() - localDate.getTimezoneOffset() * 60000
      );
      const formattedWorkDate = utcDate.toISOString();

      const data = {
        projectId: log.projectId._id,
        taskId: log.taskId._id,
        subTask: log.subTask,
        // workDate: localDate,
      };

      if (log.projectId._id === "" || log.taskId._id === "" || log.subTask === "") {
        return;
      }
      
      // if(localStorage.getItem("_id")){
      //   // alert()
      //   stopTask(localStorage.getItem("_id"))
      //   .then((response) => {
      //     clearTaskState();
      //   })
      //   .catch((error) => {});
      // }

      startTask(data)
        .then((response: any) => {
          
          const { starttime, _id } = response.data;
          setIsRunning(true);
          setIsStartTask(true);
          if (starttime && _id) {
            localStorage.setItem("starttime", starttime);
            localStorage.setItem("_id", _id);
            localStorage.setItem("selectedProject", log.projectId.project_name);
            localStorage.setItem("selectedTaskSubTaskId", log.subTask === "None" ? log.taskId.taskId : log.subTask);
            localStorage.setItem("selectedTaskSubTask", log.subTask === "None" ? log.taskId.name : log?.taskId?.subTasks?.filter((sub: any) => sub._id === log.subTask).map((sub: any) => sub.name));
          }
        

          refetch();
          refetchTotalTime();

        })
        .catch((er) => {});
    }else{

      stopTask(localStorage.getItem("_id"))
      .then((response) => {
        clearTaskState()
      })
      .catch((error) => {});
    }

  }

  const handleStartPause = () => {

    if (!isRunning) {
      const localDate = new Date(dateFc);
      const utcDate = new Date(
        localDate.getTime() - localDate.getTimezoneOffset() * 60000
      );
      const formattedWorkDate = utcDate.toISOString();

      const data = {
        projectId: projectId,
        taskId: subTaskId.id ? subTaskId.taskUniqueId : taskId,
        subTask: subTaskId.id === "" ? "None" : subTaskId.id,
        // workDate: localDate,
      };

      if (data.projectId === "" || data.taskId === "" || data.subTask === "") {
        return;
      }

      startTask(data)
        .then((response: any) => {
          const { starttime, _id } = response.data;
          setIsRunning(true);
          setIsStartTask(true);
          if (starttime && _id) {
            localStorage.setItem("starttime", starttime);
            localStorage.setItem("_id", _id);
            localStorage.setItem("selectedProject", selectedProject ? selectedProject : "");
            localStorage.setItem("selectedTaskSubTaskId", selectedTask.taskId ? selectedTask.taskId : "");
            localStorage.setItem("selectedTaskSubTask", selectedTask.task ? selectedTask.task : "");
          }
          refetch();
          refetchTotalTime()
        })
        .catch((er) => { });
    } else {
      stopTask(localStorage.getItem("_id"))
        .then((response) => {
          clearTaskState();
        })
        .catch((error) => { });
    }
  };


  const handleStartLunch=()=>{};

  const handleUpdate = (logId: string, updatedStartTime: string, type: string) => {

    if (updatedStartTime) {
      if (!isValidTime(updatedStartTime)) {
        alert('Invalid time format. Please enter a valid time in hh:mm:ss AM/PM format.');
        return;
      }
    }

    const formData = {
      [type === 'start' ? 'starttime' : 'endtime']: updatedStartTime, // Dynamically set the field name
    };

    updateTask(logId, formData)
      .then((response) => {
        refetch();
        refetchTotalTime();
        console.log('Task updated successfully', response);
      })
      .catch((error) => {
        console.error('Error updating task', error);
      });

  };

  const handleTaskUpdate = (logId: string, projectId: string, taskId: string, taskUniqueId: string, subTaskId: string) => {

    const formData = {
      projectId: projectId,
      taskId: subTaskId ? taskUniqueId : taskId,
      subTask: subTaskId === "" ? "None" : subTaskId,// Dynamically set the field name
    };

    updateTask(logId, formData)
      .then((response) => {
        refetch();
        refetchTotalTime();
        console.log('Task updated successfully', response);
      })
      .catch((error) => {
        console.error('Error updating task', error);
      });
  
  };
  
  const toggleProjectDropdown = async () => {
    setIsActiveProjectDrop((prevState) => !prevState);
  };

  const toggleTaskDropdown = () => {
    setIsActiveTaskDrop((prevState) => !prevState);
  };

  const toggleSortDropdown = () => {
    setIsActiveSortDrop((prevState) => !prevState);
  };

  const handleDelete = (id: string) => {
    const isConfirmed = window.confirm('Are you sure you want to delete this task?');
  
    if (isConfirmed) {
      deleteTask(id)
        .then((response) => {
          refetch();
          refetchTotalTime();
          console.log('Task deleted successfully', response);
        })
        .catch((error) => {
          console.error('Error deleting task', error);
        });
    }
  };

  const handleProjectClick = (id: string, projectName: string, logId?: string,) => {
    setSelectedProject(projectName);
    setProjectId(id);
    setIsActiveProjectDrop((prevState) => !prevState);
    setSelectedTask({ task: "", isSubTask: false, taskId: "" });
  };


  const toggleTaskClick = (task: any) => {
    setIsActiveTaskDrop((prevState) => !prevState);
    setTaskId(task._id);
    setSelectedTask({ task: task.name, isSubTask: false, taskId: task.taskId });
  };

  const toggleSubtaskClick = (
    taskId: string,
    taskUniqueId: string,
    subTask: any,
  ) => {

    setIsActiveTaskDrop((prevState) => !prevState);
    setSubtaskId({
      taskId: taskId,
      taskUniqueId: taskUniqueId,
      id: subTask._id,
    });
    setSelectedTask({
      task: subTask.name,
      isSubTask: true,
      taskId: subTask._id,
    });
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Close Project Dropdown if clicked outside
      if (
        projectDropdownRef.current &&
        !projectDropdownRef.current.contains(event.target as Node)
      ) {
        setIsActiveProjectDrop(false);
      }

      // if (projectsDropdownRef.current && !projectsDropdownRef.current.contains(event.target as Node)) {
        
      //   setOpenDropdownId({ project: null, task:null });
      // }

      if (
        sortDropdownRef.current &&
        !sortDropdownRef.current.contains(event.target as Node)
      ) {
        setIsActiveSortDrop(false);
      }
      // Close Task Dropdown if clicked outside
      if (
        taskDropdownRef.current &&
        !taskDropdownRef.current.contains(event.target as Node)
      ) {
        setIsActiveTaskDrop(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const isDisabled = dateFc !== format(new Date(), "yyyy-MM-dd");

  return (
    <div className="logtime-page">
      <div className="logtime-page__header">
        <div className="l-p-left">
          <div className="d-flex user-profile user-profile-sm">
            <div className="user-pic">
              <DefaultImage
                src={profilePic}
                alt=""
                className="img-fluid"
                letter={loginUser?.[0]}
              />

              {/* <img src={profilePic} alt="" className="img-fluid" /> */}
            </div>
            <div className="user-details">
              <p className="u-name">{loginUser || ""}</p>
            </div>
          </div>
          <div className="day-navigation">
            <button
              onClick={handlePrevious}
              className="day-nav-previous icon-circle-action"
            >
              <span className="material-icons-round">arrow_back</span>
            </button>
            <div className="date-month-year">
              <div className="date">{getDateLabel()}</div>
              <div className="dot"></div>
              <div className="month">{getMonth()}</div>
              <div className="year">{getYear()}</div>
            </div>
            <button
              onClick={handleNext}
              className="day-nav-forward icon-circle-action"
              disabled={isToday(currentDate)}
            >
              <span className="material-icons-round">arrow_forward</span>
            </button>
          </div>
        </div>
        <div className="l-p-right">
          <div className="note-box">
            <span>Lunch</span>
            <button
            onClick={handleStartLunch}
              className={`btn-comp l-w-timer-actions btn-icon btn-success
            `}
            >
              <span className="material-icons-round icon-play">ramen_dining</span>
              <span className="material-icons-round icon-pause">stop</span>

            </button>
          </div>
          <div className="note-box">
            <span>Tea Break</span>
            <button
              className={`btn-comp l-w-timer-actions btn-icon btn-success`}
            >
              <span className="material-icons-round icon-play">local_cafe</span>
              <span className="material-icons-round icon-pause">stop</span>


            </button>       </div>

          <div className="note-box">
            <span>Total Time Spent</span>
            <span className="highlight">
              <span className="material-icons-outlined">timer</span>
              {totalSpentTime}
            </span>
          </div>
          {/* Apply Class Below "active" */}
          <div
            ref={sortDropdownRef}
            className={`d-flex drpdwn-slct dropdown-comp ${isActiveSortDrop ? "active" : ""
              }`}
          >
            <div className="dropdown-trigger" onClick={toggleSortDropdown}>
              <span className="material-icons-round">sort</span>
              <span className="d-t-text">Sort by Task Time (New to Old)</span>
              <span className="material-icons-round">keyboard_arrow_down</span>
            </div>
            <div className="dropdown-content sort-dropdown-content">
              <div className="drop-title-block">Sort by</div>
              <div className="drop-main-block">
                <a
                  className={`d-m-item ${sortOrder === "asc" ? "active" : ""}`}
                  onClick={() => toggleSortOrder("asc")}
                >
                  <div className="d-m-i-text">Task Time</div>
                  <div className="d-m-i-details">
                    <div className="d-m-i-d-from">New</div>
                    <span className="material-icons-round">east</span>
                    <div className="d-m-i-d-to">Old</div>
                  </div>
                </a>
                <a
                  className={`d-m-item ${sortOrder === "desc" ? "active" : ""}`}
                  onClick={() => toggleSortOrder("desc")}
                >
                  <div className="d-m-i-text">Task Time</div>
                  <div className="d-m-i-details">
                    <div className="d-m-i-d-from">Old</div>
                    <span className="material-icons-round">east</span>
                    <div className="d-m-i-d-to">New</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <button className="d-flex false btn btn-success" type="button">
            <span className="material-icons-outlined">timer</span>
            <p>Add Time Log</p>
          </button>
        </div>
      </div>
      <div className="logtime-widget" {...(isDisabled && { disabled: true })}>
        {/* Apply Class Below "active" */}
        <div
          ref={projectDropdownRef}
          className={`l-w-project dropdown-comp ${isActiveProjectDrop ? "active" : ""
            }`}
        >
          <div className="dropdown-trigger" onClick={toggleProjectDropdown}>
            <div className="icon-circle-div">
              <span className="material-icons-round">folder</span>
            </div>
            <div className="dropdown-trigger-text">
              {selectedProject ? selectedProject : "Select Project"}{" "}
            </div>
            <span className="material-icons-round">keyboard_arrow_down</span>
          </div>
          <div className="dropdown-content">
            <div className="d-c-group d-c-group__header">
              <div className="d-c-g-title">
                <span>Project</span>
              </div>
              <div className="search-comp">
                <span className="material-icons-outlined">search</span>
                <input
                  type="text"
                  value={projectSearchQuery}
                  onChange={handleProjectSearch}
                  placeholder="Search"
                />
              </div>
            </div>
            <div className="d-c-group d-c-group__body">
              <div className="d-c-group-item">
                <div className="d-c-g-title">
                  <span>SCT Base Tool</span>
                </div>
                <div className="d-c-g-item-block ">
                  {projectList?.map((project: any) => (
                    <a
                      key={project._id}
                      onClick={() =>
                        handleProjectClick(project._id, project.project_name)
                      }
                      className="d-c-item d-c-project-item"
                    >
                      <div className="d-c-p-i-top">
                        <span className="material-icons-outlined">
                          fiber_manual_record
                        </span>
                        {project.project_name}
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="divider"></div>
        {/* Apply Class Below "active" "task-active" or "subtask-active" */}
        <div
          ref={taskDropdownRef}
          className={`l-w-task-subtask subtask-active dropdown-comp dropdown-lg-comp ${isActiveTaskDrop ? "active" : ""
            } ${selectedTask.isSubTask ? "subtask-active" : "task-active"}`}
        >
          <div className="dropdown-trigger" onClick={toggleTaskDropdown}>
            <div className="l-w-t-s-icon">
              <span className="material-icons-outlined default-task-icon">
                done_outline
              </span>
              <span className={`material-icons-outlined subtask-icon `}>
                subdirectory_arrow_right
              </span>
              <span className="material-icons-outlined task-icon">bolt</span>
            </div>
            <div className="l-w-t-s-code">{selectedTask.taskId}</div>
            <div className="l-w-t-s-text">
              {" "}
              {selectedTask.task
                ? selectedTask.task
                : "Select your Task/Subtask"}
            </div>
            <span className="material-icons-round">keyboard_arrow_down</span>
          </div>
          <div className="dropdown-content">
            <div className="d-c-group d-c-group__header">
              <div className="d-c-g-title">
                <span>Task/Subtask</span>
              </div>
              <div className="search-comp">
                <span className="material-icons-outlined">search</span>
                <input
                  type="text"
                  value={taskSearchQuery}
                  onChange={handleTaskSearch}
                  placeholder="Search"
                />
              </div>
            </div>
            <div className="d-c-group d-c-group__body">
              {taskSubtaskList?.length === 0 && (
                <div className='d-c-group-item'>
                  <div className="d-c-g-title no-boarder">
                    <span>No Record Founded</span>
                  </div>
                </div>
              )}
             
              <div className="d-c-group-item">
                <div className="d-c-g-title">
                  <span>{selectedProject}</span>
                </div>
                <div className="d-c-g-item-block">
                  {taskSubtaskList?.map((task: any) => (
                    <React.Fragment key={task._id}>
                      <a
                        onClick={() => {
                          toggleTaskClick(task);
                        }}
                        className="d-c-item d-c-task-item"
                      >
                        <div className="d-c-p-i-top">
                          <span className="material-icons-outlined">bolt</span>
                          <div className="l-w-t-s-code">{task.taskId}</div>
                        </div>
                        <div className="d-c-p-i-middle"> {task.name} </div>
                      </a>

                      {task.subTasks?.map((subTask: any) => (
                        <a
                          key={subTask._id}
                          onClick={() => {
                            toggleSubtaskClick(task.taskId, task._id, subTask);
                          }}
                          className="d-c-item d-c-subtask-item"
                        >
                          <div className="d-c-p-i-top">
                            <span className="material-icons-outlined">
                              subdirectory_arrow_right
                            </span>
                            <div className="l-w-t-s-code">{subTask._id}</div>
                          </div>
                          <div className="d-c-p-i-middle">{subTask.name}</div>
                        </a>
                      ))}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
            {/* <div className="d-c-group d-c-group__footer">
              <div className="search-entered-text-group">
                Create <span className='search-entered-text'> "<span>Planning about the next level of designing the tasks Page</span>" </span>
              </div>
              <div className="d-c-g-f-btn-group">
               
                <button className="d-flex false btn btn-default active" type="button">
                  <span className="material-icons-outlined">add</span><p>Tasks</p>
                </button>
                <button className="d-flex false btn btn-default" type="button">
                  <span className="material-icons-outlined">add</span><p>Subtask</p>
                </button>
              </div>
            </div> */}
          </div>
        </div>
        
        <div className="l-w-timer">{formatTime(time)}</div>
        <button
          onClick={handleStartPause}
          className={`btn-comp l-w-timer-actions btn-icon btn-success ${isStartTask ? "active" : ""
            }`}
        >
          <span className="material-icons-round icon-play">play_arrow</span>
          <span className="material-icons-round icon-pause">stop</span>
        </button>
      </div>

      <LogTimeList logsList={logsList} projectList={projectList} taskSubtaskList={taskSubtaskList} handleUpdate={handleUpdate} handleTaskUpdate={handleTaskUpdate} handleClone={handleClone} handleDelete={handleDelete} timer={formatTime(time)} />
    </div>
  );
};

export default LogTime;
